import { useContext } from 'react';
import { FeatureFlagContext } from '.';

export const useFeatureFlag = () => {
  const { flags } = useContext(FeatureFlagContext);
  return flags;
};
